import './App.css';
import {Link, useNavigate} from "react-router-dom";
import React, {useEffect, useState} from 'react';
import {utils} from "./utils/utils";
import mainLogo2 from './img/main-logo2.jpg';

function App() {
    const navigate = useNavigate();

    const [token, setToken] = useState('');
    const [userInfo, setUserInfo] = useState('');
    const [buseo, setBuseo] = useState('');
    const [qrCodeData, setQRCodeData] = useState('');
    const [countdown, setCountdown] = useState(60);

    const fetchQrCode = () => {
        const secretKey = localStorage.getItem('secretKey');
        const storedToken = localStorage.getItem('token');
        if (!storedToken || !secretKey) return;

        fetch(`/backend/QrCode_main?token=${encodeURIComponent(storedToken)}&secretKey=${encodeURIComponent(secretKey)}&t=${Date.now()}`)
            .then(response => response.blob())
            .then(data => {
                const reader = new FileReader();
                reader.onloadend = () => setQRCodeData(reader.result);
                reader.readAsDataURL(data);
            });
    };

    useEffect(() => {
        const secretKey = localStorage.getItem('secretKey');
        const storedToken = localStorage.getItem('token');
        if (storedToken) setToken(storedToken);

        if (storedToken && secretKey) {
            Promise.all([
                fetch(`/backend/user_info?token=${encodeURIComponent(storedToken)}&secretKey=${encodeURIComponent(secretKey)}`).then(res => res.json()),
                fetch(`/backend/buseo?token=${encodeURIComponent(storedToken)}&secretKey=${encodeURIComponent(secretKey)}`).then(res => res.json())
            ])
                .then(([userInfoData, buseoData]) => {
                    setUserInfo(userInfoData);
                    setBuseo(buseoData);
                })
                .catch(console.error);
        }
    }, []);

    useEffect(() => {
        fetchQrCode();
        const refreshInterval = setInterval(() => {
            fetchQrCode();
            setCountdown(60);
        }, 60000);

        return () => clearInterval(refreshInterval);
    }, []);

    useEffect(() => {
        const countdownInterval = setInterval(() => {
            setCountdown(prev => (prev > 0 ? prev - 1 : 0));
        }, 1000);

        return () => clearInterval(countdownInterval);
    }, []);

    const openExternal = (url) => window.open(url, '_blank', 'noopener,noreferrer');
    const openSSO = (dest, name, script) => utils.ssoLink(token, dest, name, script);

    const handleOpenApp = () => {
        const ua = navigator.userAgent || navigator.vendor;
        const isIOS = /iPad|iPhone|iPod/.test(ua);
        const isAndroid = /Android/.test(ua);

        const appScheme = 'kmobile://';
        const androidPackage = 'kr.ac.kangwon.kmobile';
        const iosStoreUrl = 'https://apps.apple.com/app/id1552157177';
        if (isIOS) {
            const now = Date.now();
            window.location.href = appScheme;
            setTimeout(() => {
                if (Date.now() - now < 2000) {
                    window.location.href = iosStoreUrl;
                }
            }, 1500);
        } else if (isAndroid) {
            window.location.href = `intent://#Intent;scheme=kmobile;package=${androidPackage};end`;
        } else {
            window.open('https://kmobile.kangwon.ac.kr', '_blank', 'noopener,noreferrer');
        }
    };

    const gubun = (() => {
        const gubunCode = userInfo.KM_BM_GUBUNCD;
        if (["1", "9"].includes(gubunCode)) return 'prof';
        if (["2", "3", "4", "5", "6", "7", "8"].includes(gubunCode)) return 'empl';
        if (["10", "11"].includes(gubunCode)) return 'stu';
        return '';
    })();

    const libSso = `https://gwportal.kangwon.ac.kr/portal/default/gwnu/${gubun}/library.page`;

    //www.kangwon.ac.kr

    const menuLinks = [
        // {className: 'gwnu', onClick: () => openExternal('https://www.gwnu.ac.kr')},
        {className: 'gwnu', onClick: () => openExternal('https://www.kangwon.ac.kr')},
        {className: 'intra', onClick: () => openSSO('https://lion.kangwon.ac.kr', 'intra')},
        {className: 'haksa', onClick: () => openExternal('https://www.kangwon.ac.kr/ko/bbs/718/list.do')},

        {className: 'jop', onClick: () => openExternal('https://success.gwnu.ac.kr')},

        {className: 'janghak', onClick: () => openExternal('https://www.kangwon.ac.kr/ko/conts/696/web.do')},
        {className: 'webmail', onClick: () => openSSO('https://mail.kangwon.ac.kr/sso/enpass/main')},
        {className: 'food1', onClick: () => openExternal('https://coop.gwnu.ac.kr/contents.asp?page=847')},
        {className: 'food2', onClick: () => openExternal('https://coop.gwnu.ac.kr/contents.asp?page=848')},
        {className: 'library', onClick: () => openSSO(libSso, 'lib', 'lib_sso.php')},
        {className: 'notice', onClick: () => openExternal('https://www.kangwon.ac.kr/ko/bbs/504/list.do')},
        {className: 'license', onClick: () => openExternal('https://www.gwnu.ac.kr/kr/7852/subview.do')},
        {className: 'infodesk', onClick: () => openSSO('https://www.gwnu.ac.kr/sso/enpass_login.jsp?rtUrl=info', 'infodesk')},
        {className: 'info_janghak', onClick: () => openExternal('https://www.kangwon.ac.kr/ko/bbs/750/list.do')},
        {className: 'haeksim', onClick: () => openExternal('https://high.kangwon.ac.kr')},
        {className: 'guid', onClick: () => openExternal('https://www.kangwon.ac.kr/ko/conts/426/web.do')},
        {className: 'haeram', onClick: () => openExternal('https://www.gwnu.ac.kr/kr/7886/subview.do')},
        {className: 'clinic', onClick: () => openExternal('https://cats.gwnu.ac.kr')},
        {className: 'news', onClick: () => openExternal('https://www.kangwon.ac.kr/ko/bbs/437/list.do')},
        {className: 'info_festival', onClick: () => openExternal('https://www.kangwon.ac.kr/ko/bbs/715/list.do')},
        {className: 'youtube', onClick: () => openExternal('https://www.youtube.com/@KNU1947')},
        {className: 'wifi', onClick: () => openExternal('https://itservice.kangwon.ac.kr/itservice/conts/568/web.do')},
    ];

    const handleQr = () => {
        navigate('/qr');
        // window.location.href = "/qr"; // 또는 다른 주소로 변경
    };

    return (
        <div className="page-container">
            <div className="page">
                <div className="App App-header gnb_b">
                    <header>
                        <div className="gnb_1">
                            <Link className="gnb_logo" to="/"/>
                        </div>
                    </header>
                    <div className="body">
                        <div className="ID_card">
                            {token ? (
                                <div className="ID_card_b_img">
                                    <div className="infobox">
                                        <span>{["1", "2", "3", "4", "5", "6", "7", "8", "9"].includes(userInfo.KM_BM_GUBUNCD) ? '모바일 신분증' : '모바일 학생증'}</span>
                                        <a>이름 : {userInfo.KM_BM_NAME}</a>
                                        <a>{["1", "2", "3", "4", "5", "6", "7", "8", "9"].includes(userInfo.KM_BM_GUBUNCD) ? '소속' : '학과'} : {buseo.KM_BM_HAKGWAFNM}</a>
                                        <a>{["1", "2", "3", "4", "5", "6", "7", "8", "9"].includes(userInfo.KM_BM_GUBUNCD) ? '사번' : '학번'} : {userInfo.KM_BM_ID}</a>
                                    </div>

                                    <div className="box" style={{textAlign: 'center'}}>
                                        {userInfo.KM_BM_ID === "F0078" ? (
                                            <>
                                                <img className="qr-image" src={qrCodeData} alt="QR Code" onClick={handleQr}/>
                                                <div style={{marginTop: '6px', fontSize: '12px', color: '#fff'}}>갱신까지 {countdown}초</div>
                                            </>
                                        ) : (
                                            <img style={{borderRadius: '10%'}} src={mainLogo2}/>
                                        )}
                                    </div>
                                </div>
                            ) : (
                                <div className="infobox">
                                    <span>모바일 신분증</span>
                                    <Link className="login_info" to="/Login">로그인을 해주세요</Link>
                                </div>
                            )}
                        </div>

                        <div className="gpt_box" onClick={handleOpenApp}>
                            강원대학교 춘천·삼척 바로가기
                        </div>

                        <div className="main_box">
                            <div className="main_box_gnb">
                                <span>전체메뉴</span>
                            </div>
                            <div className="menubox">
                                {["1"].includes(userInfo.KM_BM_GUBUNCD) && (
                                    <>
                                        <Link className="gyogik" to="/Gyogik">
                                            <div className="gyogik"/>
                                        </Link>
                                        <Link className="schedule" to="/schedule">
                                            <div className="schedule"/>
                                        </Link>
                                    </>
                                )}
                                {["2", "3", "4", "5", "6", "7", "8", "9"].includes(userInfo.KM_BM_GUBUNCD) && (
                                    <Link className="gyogik" to="/Gyogik">
                                        <div className="gyogik"/>
                                    </Link>
                                )}
                                {["10", "11"].includes(userInfo.KM_BM_GUBUNCD) && (
                                    <>
                                        <Link className="schedule" to="/schedule">
                                            <div className="schedule"/>
                                        </Link>
                                        <Link className="grade" to="/grade">
                                            <div className="grade"/>
                                        </Link>
                                        <Link className="scholar" to="/scholar">
                                            <div className="scholar"/>
                                        </Link>
                                    </>
                                )}

                                {menuLinks.map(({className, onClick}) => (
                                    <div key={className} className={className} onClick={onClick}></div>
                                ))}

                                <div className="knup" onClick={() => openExternal('https://knup.kangwon.ac.kr/online/latest.php')}></div>
                                {userInfo && (
                                    <div className="facility" onClick={() => openSSO('https://www.kangwon.ac.kr/sso/enpass/ko?url=/ko/bbs/758/list.do', 'facility')}></div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default App;
